import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { useCompanyQuery } from '../../../features/company/useCompanyQuery';
import { appStore } from '../../../services/appStore';
import { useAiOutreachTracking } from '../../company-overview/AIOutreachPanel/useAiOutreachTracking';

import {
  StyledBannerContainer,
  StyledButtonText,
  StyledDescription,
  StyledTextContent,
  StyledTitle,
  StyledTryAiOutreachButton,
} from './styles';

export const InsightsMigrationBanner = () => {
  const { t } = useTranslation();
  const { data: company } = useCompanyQuery();
  const tracking = useAiOutreachTracking();

  const handleTryAiOutreach = useCallback(() => {
    if (company) {
      tracking.trackOpenFromInsights();
      appStore.setAiOutreachOpen(true, company.domain, company.name);
    }
  }, [company, tracking]);

  return (
    <StyledBannerContainer data-automation="InsightsMigrationBanner">
      <StyledTextContent>
        <StyledTitle>{t('insights.migration_banner.title', 'SAM Insights are moving to AI Outreach')}</StyledTitle>
        <StyledDescription>
          {t(
            'insights.migration_banner.description',
            'This page will be deprecated in 2 weeks. Get a better experience with AI-powered outreach — all your insights, signals, and context in one place.'
          )}
        </StyledDescription>
        <StyledTryAiOutreachButton
          variant="flat"
          onClick={handleTryAiOutreach}
          data-automation="InsightsMigrationBannerTryAiOutreach"
        >
          <SWReactIcons iconName="craft-email" size="xs" iconColor={colorsPalettes.carbon[0]} />
          <StyledButtonText>{t('insights.migration_banner.try_button', 'Try AI Outreach')}</StyledButtonText>
        </StyledTryAiOutreachButton>
      </StyledTextContent>
    </StyledBannerContainer>
  );
};
